import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StructuredDataService {
  private readonly document = inject(DOCUMENT);

  public absoluteUrl(url: string) {
    if (/^https?:\/\//.test(url)) {
      return url;
    }
    return `${this.document.location.origin}${url.startsWith('/') ? url : `/${url}`}`;
  }

  public canonicalUrl(url: string) {
    const [path, query = ''] = url.split('#')[0].split('?');
    const page = Number(new URLSearchParams(query).get('page'));
    return this.absoluteUrl(path).toLowerCase() + (page > 1 ? `?page=${page}` : '');
  }

  public breadcrumbList(breadcrumbs: { title: string; url: string }[]) {
    return {
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbs.map((b, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        name: b.title,
        item: this.absoluteUrl(b.url),
      })),
    };
  }

  public set(key: string, data: object) {
    let script = this.document.head.querySelector<HTMLScriptElement>(`script[data-schema="${key}"]`);
    if (!script) {
      script = this.document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', key);
      this.document.head.appendChild(script);
    }
    script.textContent = JSON.stringify({ '@context': 'https://schema.org', ...data }).replace(/</g, '\\u003c');
  }

  public remove(key: string) {
    this.document.head.querySelector(`script[data-schema="${key}"]`)?.remove();
  }
}
